import NotFound from '@/pages/NotFound.vue'
import Guest from '@/layouts/Guest.vue'
import Register from '@/pages/auth/Register.vue'
import LoginPage from '@/pages/auth/LoginPage.vue'
import TwoFactorChallenge from '@/pages/auth/TwoFactorChallenge.vue'
import ForgotPassword from '@/pages/auth/ForgotPassword.vue'
import ResetPassword from '@/pages/auth/ResetPassword.vue'
import VerifyEmail from '@/pages/auth/VerifyEmail.vue'

import Authenticated from '@/layouts/Authenticated.vue'
import ConfirmPassword from '@/pages/auth/ConfirmPassword.vue'
import HomePage from '@/pages/HomePage.vue'
import User from '@/pages/User.vue'
import { createInterfaceComponent } from '@/lib/interfaceRegistry.js'
export default [
  {
    path: '/',
    component: createInterfaceComponent('AuthenticatedLayout', Authenticated),
    meta: { requiresAuth: true },
    children: [
      { path: "/", name: 'Home', component: createInterfaceComponent('HomePage', HomePage) },
      { path: "/user", name: 'User', component: createInterfaceComponent('UserPage', User) },
      { path: "/confirm-password", name: 'ConfirmPassword', component: createInterfaceComponent('ConfirmPasswordPage', ConfirmPassword) },
    ]
  },
  {
    path: '/auth',
    redirect: "/login",
    component: createInterfaceComponent('GuestLayout', Guest),
    meta: { isGuest: true },
    children: [
      { path: "/register", name: 'Register', component: createInterfaceComponent('RegisterPage', Register) },
      { path: "/login", name: 'Login', component: createInterfaceComponent('LoginPage', LoginPage) },
      { path: "/verify-email", name: 'VerifyEmail', component: createInterfaceComponent('VerifyEmailPage', VerifyEmail) },
      { path: "/two-factor-challenge", name: 'TwoFactorChallenge', component: createInterfaceComponent('TwoFactorChallengePage', TwoFactorChallenge) },
      { path: "/forgot-password", name: 'ForgotPassword', component: createInterfaceComponent('ForgotPasswordPage', ForgotPassword) },
      { path: "/reset-password/:token", name: 'ResetPassword', component: createInterfaceComponent('ResetPasswordPage', ResetPassword) }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: createInterfaceComponent('NotFoundPage', NotFound),
  }
]
